import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';

import { MilitaryBranch } from '../models';
import { MilitaryBranchService } from '../services/military';

export const branchListResolver: ResolveFn<MilitaryBranch[]> = (): Observable<
  MilitaryBranch[]
> => {
  const militaryBranchService = inject(MilitaryBranchService);
  return militaryBranchService.getBranchList();
};
